import { render, staticRenderFns } from "./historyTagDialog.vue?vue&type=template&id=35e5d008&scoped=true&"
import script from "./historyTagDialog.vue?vue&type=script&lang=js&"
export * from "./historyTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./historyTagDialog.vue?vue&type=style&index=0&id=35e5d008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5d008",
  null
  
)

export default component.exports